import { galleryPhotos, site } from "@/content/site";
import { asset } from "@/lib/assets";

export function Gallery() {
  // Read on render so the footer year is right without a redeploy each January.
  const currentYear = new Date().getFullYear();

  return (
    <section
      id="galeria"
      style={{ backgroundImage: `url('${asset("images/webp/gallery-bg.webp")}')` }}
      className="bg-brand-sky bg-cover overflow-hidden scroll-mt-20 lg:scroll-mt-28"
    >
      <div className="container mx-auto px-5 py-5 md:py-12 sm:pb-10 h-full relative">
        <h2 className="text-white font-extrabold uppercase text-[10vw] md:text-6xl lg:text-7xl pb-6 lg:pb-14">Galeria</h2>

        <div className="flex aspect-auto">
          <div className="grid md:grid-cols-3 grid-rows-4 gap-4 w-[100%] md:w-[60%]">
            {galleryPhotos.map((photo) => (
              <div key={photo.id} className={photo.className}>
                <img className="object-cover h-full w-full rounded-2xl" src={asset(photo.image)} alt="" loading="lazy" decoding="async" />
              </div>
            ))}
          </div>
        </div>

        <div className="absolute hidden md:block h-full right-[-12rem] bottom-[5rem] md:w-[540px] lg:w-[656px] xl:w-[750px] 2xl:w-[850px]">
          <img className="w-[100%]" src={asset("images/webp/galleryavatar.webp")} alt="" loading="lazy" decoding="async" />
        </div>

        <footer className="text-white pt-10 font-bold">
          Copyright © {site.copyrightHolder} {currentYear}. All rights reserved.
        </footer>
      </div>
    </section>
  );
}
